import React from 'react';
import './style.css';
import { ArrowLeftRight, PiggyBank, TrendingUpDown, Receipt, Plus, ArrowDownUp } from 'lucide-react';
import LabAnalysisOverviewPayoff from './Payoff/LabAnalysisOverviewPayoff';
import LabAnalysisOverviewCosts from './Costs/LabAnalysisOverviewCosts';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';

const LabAnalysisOverview = ({
    simulatorData
}) => {

    const introText = "Here is the estimated payoff and cost of doing the projects you selected:";
    return (
        <div className="lab-analysis-section-content-container">
            <h2 className="lab-analysis-section-title">Overview</h2>
            <p className="text-align-center" dangerouslySetInnerHTML={{ __html: introText }} />
            <div className="lab-analysis-financial-details">
                <LabAnalysisOverviewPayoff simulatorData={simulatorData} />
                <div className="lab-analysis-financial-details-arrows-container">
                    <ArrowDownUp />
                </div>
                <LabAnalysisOverviewCosts simulatorData={simulatorData} />
            </div>
        </div>);
};

export default LabAnalysisOverview;